/**
 * Entry de la página `/operaciones.html` — Fase 8b.
 *
 * Pizarra "Current Operations" del escuadrón. Pinta campañas y misiones
 * declarativas creadas por oficiales (no confundir con `mission_reports`,
 * que son resultados de parser).
 *
 * Iteración 8b: solo render read-only. Click en papeles inerte —
 * lo añade 8e.
 */

import { mountOperaciones } from './modules/operaciones/mount.js';

mountOperaciones();
